import { render, staticRenderFns } from "./ConstructionOrganise.vue?vue&type=template&id=939dcd6e&scoped=true"
import script from "./ConstructionOrganise.vue?vue&type=script&lang=js"
export * from "./ConstructionOrganise.vue?vue&type=script&lang=js"
import style0 from "./ConstructionOrganise.vue?vue&type=style&index=0&id=939dcd6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939dcd6e",
  null
  
)

export default component.exports